import { Formik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { PasswordField } from '@/components/UI/PasswordField';
import { RoundButton } from '@/components/UI/RoundButton';
import { strongPasswordRegex } from '@/helpers/common';
import './index.scss';

const VALIDATION_SCHEMA = t =>
  Yup.object().shape({
    oldPassword: Yup.string()
      .matches(strongPasswordRegex, t('change_pass_form.password_does_not_meet_requirements'))
      .required(t('change_pass_form.password_is_required')),
    password1: Yup.string()
      .matches(strongPasswordRegex, t('change_pass_form.password_does_not_meet_requirements'))
      .required(t('change_pass_form.password_is_required')),
    password2: Yup.string().required(t('change_pass_form.confirm_password')),
  });

export const ChangePassForm = ({ onSubmit, onCancel }) => {
  const { t } = useTranslation('components');
  return (
    <Formik
      onSubmit={onSubmit}
      validationSchema={VALIDATION_SCHEMA(t)}
      initialValues={{
        oldPassword: '',
        password1: '',
        password2: '',
      }}
    >
      {({ values, errors, setFieldValue, touched, handleChange, handleSubmit }) => (
        <form onSubmit={handleSubmit} className="change-pass-form">
          <h1 className="change-pass-form__title f-32 f-500">
            {t('change_pass_form.change_password')}
          </h1>
          <h3 className="change-pass-form__subtitle">{t('change_pass_form.type_old_password')}</h3>
          <PasswordField
            name="oldPassword"
            label={t('change_pass_form.old_password_label')}
            value={values.oldPassword}
            onChange={handleChange}
            onClear={() => setFieldValue('oldPassword', '')}
            error={errors.oldPassword && touched.oldPassword && errors.oldPassword}
            className="change-pass-form__password"
          />

          <h3 className="change-pass-form__subtitle">{t('change_pass_form.set_new_password')}</h3>
          <PasswordField
            name="password1"
            label={t('change_pass_form.password_label')}
            value={values.password1}
            onChange={handleChange}
            onClear={() => setFieldValue('password1', '')}
            error={errors.password1 && touched.password1 && errors.password1}
            className="change-pass-form__password"
          />

          <PasswordField
            name="password2"
            label={t('change_pass_form.confirm_password_label')}
            value={values.password2}
            onChange={handleChange}
            onClear={() => setFieldValue('password2', '')}
            error={
              (errors.password2 && touched.password2 && errors.password2) ||
              (values.password1 !== values.password2 &&
                touched.password2 &&
                t('change_pass_form.password_does_not_match')) ||
              ''
            }
            className="change-pass-form__password"
          />

          <div className="change-pass-form__buttons">
            {onCancel && (
              <RoundButton type="button" onClick={onCancel} label={t('change_pass_form.cancel')} />
            )}
            <RoundButton
              label={t('change_pass_form.save')}
              type="submit"
              onSubmit={handleSubmit}
              fillBackground
            />
          </div>
        </form>
      )}
    </Formik>
  );
};

export default ChangePassForm;
